<template>
  <v-layout wrap align-start>
    <v-flex>
      <v-card class="card--flex-toolbar">
        <v-toolbar flat>
          <v-toolbar-title class="grey--text">Notificaciones</v-toolbar-title>
        </v-toolbar>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-form>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-select
                    v-model="form.tipo_envio"
                    :items="tipos"
                    menu-props="auto"
                    label="Enviar a:"
                    hide-details
                    chips
                    prepend-icon="visibility"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-autocomplete
                    v-show="!inputUser"
                    v-model="users_select"
                    :items="items_users"
                    :loading="is_loading_users"
                    :search-input.sync="search"
                    hide-no-data
                    hide-selected
                    hint="Solo se mostrarán los usuarios que hallan registrado al menos un dispositivo"
                    chips
                    deletable-chips
                    multiple
                    :disabled="inputUser"
                    label="Elegir usuarios:"
                    placeholder="Nombre del usuario"
                    prepend-icon="mdi-database-search"
                    return-object
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="remove(data.item)"
                      >
                        <v-avatar
                          left
                          :color="
                            showRoleColor(data.item.role_name.substring(0, 1))
                          "
                          dark
                        >
                          <span class="white--text">{{
                            data.item.role_name.substring(0, 1)
                          }}</span>
                        </v-avatar>
                        {{ data.item.text }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-avatar
                        :color="
                          showRoleColor(data.item.role_name.substring(0, 1))
                        "
                      >
                        <span class="white--text">{{
                          data.item.role_name.substring(0, 1)
                        }}</span>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="data.item.text"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-html="data.item.role_name"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <h4>Datos de la notificación</h4>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="form.title"
                    name="title"
                    label="Titulo"
                    hint="Título a mostrar en la notificación"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="form.message"
                    name="message"
                    label="Mensaje"
                    hint="Contenido del mensaje, se recomienda mensajes cortos, dependiendo del dispositivo pudiera no mostrarse completamente el mensaje"
                    :error-messages="errors.message"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-layout>
        </v-container>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            class="white--text"
            :loading="loading"
            :disabled="loading"
            @click="enviarNotificacion"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar"
      rigth
      top
      :color="snackbar_config.color"
      :multi-line="snackbar_config.multi_line"
      :timeout="snackbar_config.timeout"
      :vertical="snackbar_config.mobile"
    >
      <div v-html="snackbar_config.text_content" />
      <v-btn dark @click="snackbar = false"> Cerrar </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import EventBus from "@/EventBus";

export default {
  name: "NotificacionesPage",
  components: {},
  data: () => ({
    errors: {},
    tipos: [
      { value: -1, text: "Todos los usuarios" },
      { value: 0, text: "Usuarios no registrados" },
      { value: 1, text: "Usuarios registrados" },
      { value: 2, text: "Usuarios específicos" },
      { value: 3, text: "Usuarios vendedores" },
    ],
    dialog: false,
    dialog_delete: false,
    dialog_change_status: false,
    estatus_list: [{ value: 0, text: "Todos" }],
    form: {
      title: "",
      message: "",
      users: [],
      tipo_envio: -1,
    },
    itemSelectId: 0,
    itemDelete: null,
    items_users: [],
    is_loading_users: false,
    loading: false,
    loading_cancelar: false,
    loading_estatus: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: "created_at",
      totalItems: 0,
    },
    pedido_select: null,
    search: "",
    snackbar: false,
    snackbar_config: {
      color: "",
      multi_line: false,
      timeout: 6000,
      mobile: false,
      text_content: "",
    },
    filter: {
      desde: null,
      hasta: null,
      cuenta_id: null,
      anonimo: -1,
      estatus_id: 0,
    },
    modal_desde: false,
    modal_hasta: false,
    users_select: [],
  }),
  computed: {
    editItem() {
      if (this.itemSelectId) {
        return this.pedidos.find((item) => item.id === this.itemSelectId);
      } else {
        return {};
      }
    },
    inputUser() {
      if (this.form.tipo_envio === 2) {
        return false;
      }
      return true;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    inputUser(val) {
      if (val === false) {
        this.users_select = [];
      }
    },
    search(val) {
      if (
        this.is_loading_users ||
        typeof val !== "string" ||
        (typeof val === "string" && val.length < 1)
      )
        return;

      this.errors = {};
      this.is_loading_users = true;

      // Lazily load input items
      this.$http
        .get("/api/notificaciones/devices", {
          params: { term: this.search },
        })
        .then((response) => {
          this.items_users = response.data.data.map((user) => {
            return {
              value: user.dispositivos.map((device) => device.id), //device_id
              text: `${user.nombre_completo}`,
              role_name: user.role_name,
            };
          });
        })
        .finally(() => {
          this.is_loading_users = false;
        });
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.itemSelectId = 0;
    },
    enviarNotificacion() {
      let datos = Object.assign({ users: [] }, this.form);
      if (this.form.tipo_envio === 2) {
        datos.users = this.users_select.map((device) => device.value).flat(2);
      }

      EventBus.$emit("tugarrafon:show-progress-dialog", "Enviando datos ...");

      this.$http
        .post("/api/notificaciones", datos)
        .then(() => {
          EventBus.$emit("tugarrafon:show-snackbar", {
            text_content: "Notificación enviada",
          });
          this.form.message = "";
          this.form.title = "";
        })
        .catch((err) => {
          if (err.response.status == 422) {
            this.errors = err.response.data.errors;
          }
          EventBus.$emit("tugarrafon:show-snackbar", {
            text_content: "Error al enviar la notificación",
          });
        })
        .finally(() => {
          EventBus.$emit("tugarrafon:hide-progress-dialog");
        });
    },
    editItemId(itemId) {
      this.itemSelectId = parseInt(itemId);
      this.dialog = true;
    },
    saveItem() {
      this.dialog = false;
      this.listar();
    },
    showRoleColor(type) {
      let color = "";
      switch (type) {
        case "C":
          color = "blue";
          break;
        case "V":
          color = "purple";
          break;
        case "A":
          color = "red";
          break;
        case "G":
          color = "indigo";
          break;
        default:
          color = "green";
      }
      return color;
    },
  },
};
</script>

<style scoped>
</style>
